export default __webpack_public_path__ + "static/media/box.064ccb48.svg";